import { Deal } from '@ca/common/types'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useMemo } from 'react'
import useBundleType from './useBundleType'
import { getDealVariant } from './useDeal'
import useOrderValues from './values/useOrderValues'

export const useDealVariant = (deal: Deal) => {
  const orderValues = useOrderValues({})
  const config = useRemoteConfig()

  return useMemo(() => {
    return getDealVariant(deal, orderValues, config)
  }, [deal, orderValues, config])
}

export const useDealsVariants = (deals: Deal[]) => {
  const { bundleType } = useBundleType()
  const orderValues = useOrderValues({ bundleType })
  const config = useRemoteConfig()

  return useMemo(() => {
    return deals.map((deal) => getDealVariant(deal, orderValues, config))
  }, [deals, orderValues, config])
}
